"use client";

import { BookOpen, Heart, ShieldCheck, Sparkles, Star, Sun } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheInfinixApproach() {
  const headerReveal = useRevealOnScroll<HTMLDivElement>();
  const contentReveal = useRevealOnScroll<HTMLDivElement>();
  const statsReveal = useRevealOnScroll<HTMLDivElement>();
  const stats = [{
    icon: "book",
    number: "100%",
    label: "CLIENT-FOCUSED APPROACH",
    bg: "bg-blue-600/20",
    iconColor: "text-blue-600",
    rotation: "-rotate-1"
  }, {
    icon: "sun",
    number: "3",
    label: "CORE SERVICE AREAS",
    bg: "bg-blue-600/30",
    iconColor: "text-blue-600",
    rotation: "rotate-1"
  }, {
    icon: "heart",
    number: "1:1",
    label: "TAILORED APPROACH",
    bg: "bg-blue-600/40",
    iconColor: "text-blue-600",
    rotation: "-rotate-1"
  }, {
    icon: "star",
    number: "0",
    label: "ONE-SIZE-FITS-ALL SOLUTIONS",
    bg: "bg-blue-600/30",
    iconColor: "text-blue-600",
    rotation: "rotate-1"
  }];
  const teachers = [];
  const renderIcon = (icon: string, className: string) => {
    if (icon === "book") return <BookOpen className={className} />;
    if (icon === "sun") return <Sun className={className} />;
    if (icon === "heart") return <Heart className={className} fill="currentColor" />;
    return <Star className={className} fill="currentColor" />;
  };
  return;
}